import axios from 'axios';
import notification from '../utils/notification';
import { FETCH_PAYMENT_DETAILS } from './types';

const formatPaymentDetails = (paymentDetails) => ({
	...paymentDetails,
	paymentDetails: `${paymentDetails.brand} ••••${paymentDetails.last4} ${paymentDetails.exp_month}/${paymentDetails.exp_year}`,
});

export const fetchPaymentDetails = () => async (dispatch) => {
	const res = await axios.get('/api/billing/payment-details');

	const formatted = formatPaymentDetails(res.data);
	dispatch({ type: FETCH_PAYMENT_DETAILS, payload: formatted });
};

export const updateBillingEmail = (newEmail) => async (dispatch) => {
	try {
		const res = await axios.post('/api/billing/update-email', { newEmail });
		const { title, message, error } = res.data;

		dispatch(notification(title, message, error));
		return res.data;
	} catch (err) {
		const serverData = err && err.response && err.response.data;
		const message =
			(serverData && serverData.message) ||
			'There was an error updating your settings.';

		dispatch(
			notification(
				'Error',
				message,
				true
			)
		);
		return serverData || { error: true, message };
	}
};

// eslint-disable-next-line import/prefer-default-export
export const updatePaymentMethod = (paymentMethodId) => async (dispatch) => {
	try {
		const res = await axios.post('/api/billing/update-payment-method', {
			paymentMethodId
		});

		if (res.data && res.data.error) {
			return {
				error: true,
				message:
					'There was an error updating your payment information. Please refresh the page and try again.'
			};
		}

		const getPayment = await axios.get('/api/billing/payment-details');

		const formatted = formatPaymentDetails(getPayment.data);

		dispatch({ type: FETCH_PAYMENT_DETAILS, payload: formatted });

		dispatch(
			notification(
				'Success',
				`Updated payment method to card ending in ${getPayment.data.last4}`,
				false
			)
		);

		return { error: false };
	} catch (err) {
		dispatch(
			notification(
				'Error',
				'There was an error updating your payment details.',
				true
			)
		);

		return { error: true };
	}
};



// WEBPACK FOOTER //
// ./src/actions/settings.js